module.exports = "/_next/static/images/takeout_pancake_top-1cc8d300e8f3dfa64dd9673813d562a2.jpg";